
export default {
  setProducts(state, payload) {

    state.products = payload.dataProducts;
  },
}